<template>
  <div v-if="visible" id="tabVesselEq" class="tab-vessel-eq">
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form label-width="85px" label-position="right" :disabled="!isEdit">
            <div>
              <span class="title">{{ $t('SeaExport.BookingInfo') }}</span>
              <el-form-item class="warn-label" :label="$t('SeaExport.FlightNo')">
                <el-input v-model="form.voyageFlight" no="6" disabled />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.MasterBillNo')">
                <div style="display: flex;flex-direction: row;padding-right: 3px;">
                  <el-input v-show="isInputMbl" v-model="form.mbl" no="7" disabled :class="form.mbl==='CANCELLED'?'mbl-red':''" />
                  <el-input v-show="!isInputMbl" v-model="form.mbl" no="8" disabled :class="form.mbl==='CANCELLED'?'mbl-red':''" @input="mblConfig.curRule = null" />
                  <span v-show="showButton" class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" @click="pm.showMBLDetailBtnClickHandler()">⊙</span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.SoNo')">
                <so-no-input v-model="form.jobSoNo" no="27" :disabled="!isEdit" />
              </el-form-item>
              <el-form-item class="warn-label" :label="$t('SeaExport.BookingDate')">
                <el-date-picker
                  v-model="form.bookingDate"
                  no="bookingDate"
                  :disabled="!isEdit"
                  type="date"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.BookingNo')">
                <el-input v-model="form.bookingNo" :disabled="!isEdit" no="9" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.quotationNum')">
                <el-input v-model="form.quotationNum" :disabled="!isEdit" no="12" />
              </el-form-item>
              <br>
              <span class="title">{{ $t('SeaExport.MultiJourneyAirline') }}</span>
              <dev style="float: right;margin-right: 80px;">
                <el-button v-show="isEdit || exportToImportEnableEdit" size="mini" type="primary" @click="addAirline">{{ $t('SystemMaintenance.Add') }}</el-button>
                <el-button v-show="isEdit || exportToImportEnableEdit" :disabled="!clickedAirline" size="mini" type="primary" @click="deleteAirline">{{ $t('SystemMaintenance.Delete') }}</el-button>
              </dev>
              <cargo-ag-grid
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                :show-side-bar="false"
                style="width:100%;"
                @gridReady="params=>{gridApi=params.api}"
              />
            </div>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="!isEdit" label-width="150px" label-position="right">
            <span class="title">{{ $t('SeaExport.PolAirPortInfo') }}
              <el-tooltip class="item" effect="dark" :content="$t('SeaExport.PolPortInfoPrompt')" placement="top-start">
                <i class="el-icon-warning-outline" />
              </el-tooltip>
            </span>
            <!-- 机场 -->
            <el-form-item :label="$t('SeaExport.Airport')">
              <el-input
                v-model="form.airport"
                no="19"
                :disabled="Boolean(form.lclMasterUuid)"
              />
            </el-form-item>
            <!-- 实际进场时间 -->
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_ActualEntryTime')">
              <el-date-picker
                ref="actualEntryTime"
                v-model="form.actualEntryTime"
                no="20"
                :disabled="Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualEntryTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际配载时间 -->
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_ActualLoadingTime')">
              <el-date-picker
                ref="actualLoadingTime"
                v-model="form.actualLoadingTime"
                no="21"
                :disabled="Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualLoadingTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 预计起飞时间 -->
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_EstimatedDepartureTime')">
              <el-date-picker
                ref="estimatedDepartureTime"
                v-model="form.estimatedDepartureTime"
                no="22"
                :disabled="Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedDepartureTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际起飞时间 -->
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_ActualDepartureTime')">
              <el-date-picker
                ref="actualDepartureTime"
                v-model="form.actualDepartureTime"
                no="23"
                :disabled="Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualDepartureTime', null, true, true, form) }"
              />
            </el-form-item>
            <span class="title">{{ $t('SeaExport.PodAirPortInfo') }}</span>
            <span style="font-weight: lighter;">{{ $t('SeaExport.LocalTime') }}</span>
            <!-- 预计抵达时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('CargoMsg.Cargo_EstimatedArrivalTime')">
              <el-date-picker
                ref="estimatedArrivalTime"
                v-model="form.estimatedArrivalTime"
                no="estimatedPortDischargeTime"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedArrivalTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际抵达时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('CargoMsg.Cargo_ActualArrivalTime')">
              <el-date-picker
                ref="actualArrivalTime"
                v-model="form.actualArrivalTime"
                no="34"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualArrivalTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际收单时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('CargoMsg.Cargo_ActualBillingTime')">
              <el-date-picker
                ref="actualReceivingTime"
                v-model="form.actualReceivingTime"
                no="actualReceivingTime"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualReceivingTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际卸货时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('CargoMsg.Cargo_ActualUnloadingTime')">
              <el-date-picker
                ref="actualUnloadingTime"
                v-model="form.actualUnloadingTime"
                no="35"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualUnloadingTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际到货通知时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('CargoMsg.Cargo_ActualArrivalNotificationTime')">
              <el-date-picker
                ref="actualArrivalNotificationTime"
                v-model="form.actualArrivalNotificationTime"
                no="actualArrivalNotificationTime"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualArrivalNotificationTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际提货时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('CargoMsg.Cargo_ActualPickupTime')">
              <el-date-picker
                ref="actualPickupTime"
                v-model="form.actualPickupTime"
                no="36"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualPickupTime', null, true, true, form) }"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="!isEdit" label-width="110px" label-position="right">
            <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
            <el-form-item v-show="showButton" :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
              <el-date-picker
                ref="estimatedWarehouseDeliveryTime"
                v-model="form.estimatedWarehouseDeliveryTime"
                no="41"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedWarehouseDeliveryTime', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item v-show="showButton" :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
              <el-date-picker
                ref="actualWarehouseDeliveryTime"
                v-model="form.actualWarehouseDeliveryTime"
                no="42"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualWarehouseDeliveryTime', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item v-show="showButton" :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                ref="estimatedShippingTime"
                v-model="form.estimatedShippingTime"
                no="43"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedShippingTime', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                ref="actualShippingTime"
                v-model="form.actualShippingTime"
                no="44"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualShippingTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 预计送达时间 -->
            <el-form-item v-show="showButton" :label="$t('AirExport.EstimatedArrivalTime')">
              <el-date-picker
                ref="estimatedTimeOfDelivery"
                v-model="form.estimatedTimeOfDelivery"
                no="32"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedTimeOfDelivery', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 实际送达时间 -->
            <el-form-item v-show="showButton" :label="$t('AirExport.ActualArrivalTime')">
              <el-date-picker
                ref="actualDeliveryTime"
                v-model="form.actualDeliveryTime"
                no="33"
                type="datetime"
                :disabled="Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('actualDeliveryTime', null, true, true, form) }"
              />
            </el-form-item>
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item :label="$t('SeaExport.EquipmentReceiptAddress')">
              <el-input v-model="form.shippingAddress" type="textarea" :rows="3" no="49" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentReceiptContactPerson')">
              <el-input v-model="form.shippingContactPerson" no="50" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentReceiptContactWay')">
              <el-input v-model="form.shippingContactInfo" no="51" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocCutOffDate')">
              <el-date-picker
                ref="fileCutoff"
                v-model="form.fileCutoff"
                no="52"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('fileCutoff', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerClosingTime')">
              <el-date-picker
                ref="customerFileCutoff"
                v-model="form.customerFileCutoff"
                no="56"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('customerFileCutoff', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
              <el-date-picker
                ref="customCutoff"
                v-model="form.customCutoff"
                no="54"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('customCutoff', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerCyCutOffDate')">
              <el-date-picker
                ref="customerCutoff"
                v-model="form.customerCutoff"
                no="55"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('customerCutoff', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerShutOutDate')">
              <el-date-picker
                ref="customerShutout"
                v-model="form.customerShutout"
                no="56"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('customerShutout', null, true, true, form) }"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.remarks')">
              <el-input v-model="form.customerRemark" no="66" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="!isEdit" class="form-card" label-width="130px" label-position="right" style="height:100%">
            <!-- 二程信息 -->
            <span class="title">{{ $t('SeaExport.AirSecondVesselInfo') }}</span>
            <span style="font-weight: lighter;">{{ $t('SeaExport.LocalTime') }}</span>
            <el-tooltip
              :content="$t('Message.IntermediateAirline')"
              placement="right-end"
            >
              <i
                class="el-icon-warning red"
                style="cursor: pointer"
              />
            </el-tooltip>
            <el-form-item class="warn-label" :label="$t('SeaExport.FlightNo')">
              <el-input v-model="form.secondFlight" disabled no="64" />
            </el-form-item>
            <!-- 起运港 -->
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_SecondPolCode')">
              <cargo-advance-select
                ref="secondPolCode"
                no="secondPolCode"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="form.secondPolCode"
                tag-name="code"
                style="flex:1"
                @parentCallBack="p=>{form.secondPolCode=p.value;form.secondPol=p.englishName;}"
              />
            </el-form-item>
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_SecondPol')">
              <el-input v-model="form.secondPol" no="secondPol" />
            </el-form-item>
            <!-- 二程目的港(代码) -->
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_SecondPodCode')">
              <cargo-advance-select
                ref="secondPodCode"
                disabled
                no="secondPodCode"
                :select-type="selectTypeNames.basic_data_Airport"
                filterable
                :default-value="form.secondPodCode"
                tag-name="code"
                style="flex:1"
              />
            </el-form-item>
            <el-form-item class="warn-label" :label="$t('CargoMsg.Cargo_SecondPod')">
              <el-input v-model="form.secondPod" disabled no="secondPod" />
            </el-form-item>
            <!-- 预计抵达中转时间 -->
            <el-form-item :label="$t('CargoMsg.Cargo_EstimatedTransitArrivalTime')" class="warn-label">
              <el-date-picker
                ref="estimatedTransferArrivalTime"
                v-model="form.estimatedTransferArrivalTime"
                no="estimatedTransferArrivalTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedTransferArrivalTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 抵达中转时间 -->
            <el-form-item :label="$t('CargoMsg.Cargo_TransitArrivalTime')" class="warn-label">
              <el-date-picker
                ref="transferArrivalTime"
                v-model="form.transferArrivalTime"
                no="transferArrivalTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('transferArrivalTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 预计中转起飞时间 -->
            <el-form-item :label="$t('CargoMsg.Cargo_EstimatedTransitDepartureTime')" class="warn-label">
              <el-date-picker
                ref="estimatedTransferDepartureTime"
                v-model="form.estimatedTransferDepartureTime"
                no="estimatedTransferDepartureTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('estimatedTransferDepartureTime', null, true, true, form) }"
              />
            </el-form-item>
            <!-- 中转起飞时间 -->
            <el-form-item :label="$t('CargoMsg.Cargo_TransitDepartureTime')" class="warn-label">
              <el-date-picker
                ref="transferDepartureTime"
                v-model="form.transferDepartureTime"
                no="transferDepartureTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @blur="()=> { handleBlur('transferDepartureTime', null, true, true, form) }"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <generate-mbl-no-dialog
      :visible="mblConfig.visible"
      :form="form"
      :config="mblConfig"
      @close="mblConfig.visible =false"
    />
    <generate-so-no-dialog
      :visible="soNoConfig.visible"
      :form="form"
      :config="soNoConfig"
      :mbl-config="mblConfig"
      @close="soNoConfig.visible =false"
    />
    <el-dialog
      :title="$t('Message.WarmReminder')"
      :visible.sync="prompt.dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>{{ prompt.message1 }}</span>
      <br>
      <span>{{ prompt.message2 }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">{{ $t('Message.Determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabVesselEqPM } from './tabVesselEqPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoMultiSelect from '@/components/Cargo/Common/cargoMultiSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import dialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import GenerateMblNoDialog from '@/views/cargo/v0/SeaExport/components/booking/GenerateMblNoDialog'
import GenerateSoNoDialog from '@/views/cargo/v0/SeaExport/components/booking/tabs/GenerateSoNoDialog'
import { allocateSoNo } from '@/api/seaExport/mbl'
import DateUtils from '@/utils/dateUtils'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { cache, cacheName } from '@/utils/cacheManager'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { getAirlineData } from '@/api/partner/airline'
import { isAirDataServiceOpen } from '@/api/seaExport/dataTracking'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { handleBlur } from '@/utils/commonUtil'

export default {
  name: 'TabAirVesselEq',
  components: {
    GenerateSoNoDialog,
    GenerateMblNoDialog,
    cargoAdvanceSelect,
    cargoMultiSelect,
    cargoCompanySelect,
    soNoInput,
    dialogSelector,
    cargoButtonContainer,
    cargoInput,
    cargoRichTextarea
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    showButton: { // 显示关联业务进来为false
      type: Boolean,
      default: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    job: { type: Object, required: true }
  },
  data() {
    return {
      handleBlur,
      isZh: this.$store.getters.language === 'zh',
      text: '',
      jobUuid: '',
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabVesselEqPM(this),
      selectTypeNames: TYPE_NAMES,
      isCrossTenant: false,
      form: new AirExportJob().fillDefaultValue().getData(),
      mblConfig: {
        visible: false,
        rule: '',
        identificationCode: '',
        curRule: null
      },
      soNoConfig: {
        visible: false,
        ruleType: '',
        split: '',
        generateCount: ''
      },
      isInputMbl: true, // 是否允许手动输入MBL,默认允许
      maxChars: 34,
      warningCount: 0,
      isUppercase: true,
      masterFlag: false,
      oldVessel: '',
      secondPort: '',
      dataServiceOpen: false,
      exportToImportEnableEdit: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        singleClickEdit: true,
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: false
        },
        onRowClicked: this.onCarrierGridRowClickedEvent
      },
      gridApi: null,
      rowData: [],
      prompt: {
        dialogVisible: false,
        message1: '',
        message2: '',
        type: 0
      },
      clickedAirline: null,
      clickedKey: ''
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return (this.form.relatedJob && !this.isCrossTenant) || this.action === 'look' || (this.action !== 'look' && !!this.form.uuid)
    },
    isEdit() {
      if (this.exportToImportEnableEdit) {
        return this.action !== 'look' && (!this.form.uuid || (this.form.uuid))
      }
      if (!this.cooperateEdit) return false
      return (!this.form.relatedJob || this.isCrossTenant) && this.action !== 'look' && (!this.form.uuid || (this.form.uuid))
    },
    config() {
      return this.context.config
    },
    isFba() { // 是否是FBA业务
      return this.form.fba
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.NumberPasses'),
          colId: 'index',
          field: 'index',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.AirlineCompany'),
          width: 190,
          field: 'airlineCompany',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          editable: !!this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              style: 'width: 100%',
              methodParams: { active: true },
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                if (item.airCmp) {
                  return true
                }
                return false
              },
              filterable: true
            }
          },
          onCellValueChanged: (params) => {
            this.airlineChanged(params)
          }
        }
      ]
    }
  },
  async created() {
    this.context.loading = true
    const loading = getLoading4Cxt(this)
    try {
      this.isInputMbl = Number(this.config.get('EditMblNoMode')) === 0
      this.exportToImportEnableEdit = Number(this.config.get('exportToImportEnableEdit')) === 1
      await this.pm.init()
    } finally {
      this.visible = true
      loading.close()
      this.context.loading = false
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      await cache.load(cacheName.CONFIG)
      this.oldVessel = row.vessel || ''
      if (isRefresh) {
        this.form = row
        if (!this.isEdit) {
          this.initData()
        }
        await this.pm.changeJob()
        await this.pm.fillView()
      }
      // 有主单号且不是快递时，才会格式化主单号添加"-"
      if (row.mbl && !row.express) {
        this.form.mbl = AirExportUtils.mawbNoDispalyFormat(row.mbl)
      }
    },
    async getSubmitData() {
      this.validateForm()
      // CARGO-23318 订舱页签的 主单号栏位 和SONO.栏位 保存数据时自动去除空格
      if (this.form.mbl) {
        this.form.mbl = this.form.mbl.trim()
        // 不是快递时，保存时去除"-"字符
        if (!this.form.express) {
          this.form.mbl = this.form.mbl.replace(/-/g, '')
        }
      }
      if (this.form.soNo) {
        this.form.soNo = this.form.soNo.trim()
      }
      if (this.rowData) {
        this.form.multipassAirline = this.rowData.reduce((accumulator, currentItem) => {
          if (currentItem.airlineCompany) {
            if (accumulator) {
              accumulator += ','
            }
            accumulator += currentItem.airlineCompany
          }
          return accumulator
        }, '')
      } else {
        this.form.multipassAirline = ''
      }
      const job = { ...this.form }
      console.log(job)
      return {
        job
      }
    },
    validateForm() {
      // const form = this.form
      // // 截关日期不能大于开航日期
      // if (form.customCutoff && form.etd) {
      //   const etd = new Date(form.etd)
      //   const customCutoff = new Date(form.customCutoff)
      //   const diff = DateUtils.getBetweenDays(customCutoff, etd)
      //   if (diff < 0) {
      //     throw new TabError(this.$t('Message.CyCutoffDateCannotBeLaterThanDepartureDate'), 'tabAirVesselEq')
      //   }
      // }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.jobuuid = this.form.uuid
      params.JOB_UUID = this.form.uuid
      params.category = 'BACNKLETTER'
      params.ctx = new AirExportJob(this.form)
      // this.$logger.log('params', params)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(view.job, "BACNKLETTER", params, view);
    },
    generateMblNo() {
      if (this.form.mbl) {
        this.$confirm(this.$t('SeaExport.TheBeVoidedAndThis'), this.$t('Message.Warning'), { type: 'warning', showClose: false }).then(res => {
          this.mblConfig.visible = true
        })
      } else {
        this.mblConfig.visible = true
      }
    },
    allocateSoNo() { // CARGO-15389
      allocateSoNo(this.form.jobUuid).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('success')
      }).finally(() => {
        self.loading.close()
      })
    },
    generateSoNo() {
      this.soNoConfig.visible = true
    },
    initData() {
      this.rowData = []
      if (this.form.multipassAirline) {
        const airlineList = this.form.multipassAirline.split(',').map(Number)
        for (let i = 0; i < airlineList.length; i++) {
          const airline = airlineList[i]
          const airlineData = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Company, item => item.cmpIdx === airline)
          if (airlineData) {
            this.rowData.push({
              index: i + 1,
              airlineCompany: airline
            })
          }
        }
      } else if (this.form.carrierId) {
        this.rowData = [{ index: 1, airlineCompany: this.form.carrierId }]
      }
      // 是否开通数据服务
      isAirDataServiceOpen({ tenantId: this.form.tenantId }).then(res => {
        this.dataServiceOpen = res.data
      })
    },
    addAirline() {
      const size = this.rowData.length + 1
      this.rowData.push({
        index: size
      })
    },
    async deleteAirline() {
      if (!this.clickedAirline) {
        return
      }
      const index = this.rowData.indexOf(this.clickedAirline)
      if (index !== -1) {
        if (index === 0) {
          this.prompt.dialogVisible = true
          this.prompt.message1 = this.$t('Message.DoNotEmpty')
          return
        }
        const params = { data: { airlineCompany: this.clickedAirline.airlineCompany || '', index: index + 1, delete: true }}
        await this.airlineChanged(params)
        this.rowData.splice(index, 1)
        this.gridApi.clearRangeSelection()
      }
      this.clickedAirline = null
      this.gridApi.setRowData(this.rowData)
    },
    async airlineChanged(params) {
      // 没有开通数据服务则不会弹框提示
      if (!this.dataServiceOpen) {
        return
      }
      // 如果选择了航司则去获取航司代码、数据服务供应商
      if (params.data.airlineCompany) {
        await getAirlineData({ cmpIdx: params.data.airlineCompany }).then(res => {
          params.data.airlineCode = res.data.airlineCode
          params.data.subscribeSource = res.data.subscribeSource
        })
      }
      // 是一程的数据
      if (params.data.index === 1) {
        // 清空的情况下，不允许
        // 删除的情况下
        if (!params.newValue && params.oldValue && params.newValue !== params.oldValue) {
          const key = params.newValue + '-' + params.oldValue
          params.data.airlineCompany = params.oldValue
          this.gridApi.refreshCells({ force: true })
          if (key === this.clickedKey) {
            return
          } else {
            this.clickedKey = key
            this.prompt.dialogVisible = true
            this.prompt.message1 = this.$t('Message.DoNotEmpty')
          }
          return
          // 修改的情况喜下
        } else if (params.newValue !== params.oldValue && params.oldValue && params.newValue) {
          this.clickedKey = params.newValue + '-' + params.oldValue
          // 如果航司支持数据服务
          if (params.data.subscribeSource) {
            this.prompt.dialogVisible = true
            this.prompt.type = 1
            this.prompt.message1 = this.$t('Message.AirlineReplacement')
          } else {
            // 如果航司不支持数据服务
            this.prompt.dialogVisible = true
            this.prompt.type = 1
            this.prompt.message1 = this.$t('Message.AirlineReplacement1')
            this.prompt.message2 = this.$t('Message.AirlineReplacement2')
          }
        }
      } else if (params.data.index === this.rowData.length) {
        // 当修改，新增，最后一程航司的时候
        if (params.newValue && params.newValue !== params.oldValue) {
          if (params.data.subscribeSource) {
            this.prompt.dialogVisible = true
            this.prompt.type = 2
            this.prompt.message1 = this.$t('Message.AirlineReplacementLast')
          } else {
            this.prompt.dialogVisible = true
            this.prompt.type = 2
            this.prompt.message1 = this.$t('Message.AirlineReplacement1')
            this.prompt.message2 = this.$t('Message.AirlineReplacementLast2')
          }
        } else if ((!params.newValue && params.oldValue) || params.data.delete) {
          // 删除最后一程的时候
          this.prompt.dialogVisible = true
          this.prompt.type = 2
          this.prompt.message1 = this.$t('Message.AirlineReplacementLast')
        }
      } else {
        if (params.newValue && params.newValue !== params.oldValue && !params.data.delete) {
          if (!params.data.subscribeSource) {
            this.prompt.dialogVisible = true
            this.prompt.type = 0
            this.prompt.message1 = this.$t('Message.IntermediateAirline')
          }
        }
      }
    },
    confirm() {
      this.prompt.dialogVisible = false
      this.prompt.message1 = ''
      this.prompt.message2 = ''
      if (this.prompt.type === 1) {
        this.form.airport = ''
        this.form.actualEntryTime = ''
        this.form.actualLoadingTime = ''
        this.form.estimatedDepartureTime = ''
        this.form.actualDepartureTime = ''
      } else if (this.prompt.type === 2) {
        this.form.estimatedArrivalTime = ''
        this.form.actualArrivalTime = ''
        this.form.actualReceivingTime = ''
        this.form.actualUnloadingTime = ''
        this.form.actualArrivalNotificationTime = ''
        this.form.actualPickupTime = ''
      }
      this.prompt.type = 0
    },
    airlineVerification() {
      let flag = false
      if (this.rowData) {
        for (let i = this.rowData.length - 1; i >= 0; i--) {
          const item = this.rowData[i]
          if (item.airlineCompany) {
            flag = true
          }
          // 如果中间存在空值则提示，并且不让保存
          if (flag && !item.airlineCompany) {
            this.$message.error(this.$t('Message.PleaseFillInCorrectly'))
            return false
          }
        }
        // 如果开通了数据服务，则进行判断逻辑
        if (this.dataServiceOpen) {
          const track17 = this.rowData.filter(item => item.subscribeSource === '2')
          if (track17.length > 1) {
            let message = ''
            for (let i = 0; i < track17.length; i++) {
              const item = track17[i]
              message += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.airlineCompany, 'chineseName')
              if (i < track17.length - 1) {
                message += '、'
              }
            }
            this.$message.warning(this.$t('Message.NotSupported', [message]))
          }
        }
      }
      return true
    },

    onCarrierGridRowClickedEvent(e) {
      this.clickedAirline = e.data
    }
  }
}
</script>

<style lang="scss" scoped>
  .tab-vessel-eq {
    /deep/ .el-submenu__title{
      border-bottom: none !important;
    }
    .warn-label .el-form-item__label{
      color: orange !important;
    }
    .mbl-red{
      .el-input__inner {
        color: red !important;
      }
    }
  }
</style>
